/* RESPONSIBLE TEAM: team-ai-agent */
import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { type Router } from '@ember/routing';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import type ReactTeammateAppIslandService from 'embercom/services/react-teammate-app-island';
import type IntercomConfirmService from 'embercom/services/intercom-confirm-service';
import type IntlService from 'embercom/services/intl';
import { action } from '@ember/object';
import type Transition from '@ember/routing/transition';

class AutomationFinAiAgentSalesGuidanceRoute extends Route {
  @service declare appService: AppService;
  @service declare router: Router;
  @service declare reactTeammateAppIsland: ReactTeammateAppIslandService;
  @service declare intercomConfirmService: IntercomConfirmService;
  @service declare intl: IntlService;
  @service declare permissionsService: $TSFixMe;

  private hasUnsavedChanges = false;
  private unsubscribeDirtyState?: () => void;

  reactEnabled() {
    return true;
  }

  beforeModel(transition: Transition) {
    this.permissionsService.ensurePermissionWhenTransitioning(
      'can_create_and_edit_bots',
      transition,
    );

    if (!this.appService.app.canUseFinSdrTeammateUi) {
      this.router.transitionTo('apps.app.automation.fin-ai-agent.setup');
    }
  }

  activate() {
    this.unsubscribeDirtyState = this.reactTeammateAppIsland.subscribeToTeammateAppEvent(
      'fin-sdr:dirty-state-changed',
      (data) => {
        let { isDirty } = data as { isDirty: boolean };
        this.hasUnsavedChanges = isDirty;
      },
    );
  }

  deactivate() {
    this.unsubscribeDirtyState?.();
    this.hasUnsavedChanges = false;
  }

  @action
  async willTransition(transition: Transition) {
    if (this.hasUnsavedChanges) {
      transition.abort();

      let confirmOptions = {
        title: this.intl.t('ai-agent.sales-development.unsaved-changes-modal.title'),
        confirmButtonText: this.intl.t('ai-agent.sales-development.unsaved-changes-modal.confirm'),
        cancelButtonText: this.intl.t('ai-agent.sales-development.unsaved-changes-modal.cancel'),
        body: this.intl.t('ai-agent.sales-development.unsaved-changes-modal.body'),
        primaryButtonType: 'primary-destructive' as const,
      };

      let isConfirmed = await this.intercomConfirmService.confirm(confirmOptions);
      if (!isConfirmed) {
        return;
      }

      this.hasUnsavedChanges = false;
      transition.retry();
    }
  }
}

export default ReactRoute(AutomationFinAiAgentSalesGuidanceRoute, {
  overrideRenderTemplate: false,
});
